import { render, staticRenderFns } from "./CalendarEventCategory.vue?vue&type=template&id=0ead47ed&scoped=true&"
import script from "./CalendarEventCategory.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventCategory.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventCategory.vue?vue&type=style&index=0&id=0ead47ed&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead47ed",
  null
  
)

export default component.exports